import React, { Component } from "react";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Preview.css";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import DownloadLink from "./../../../util/downloader/DownloadLink";
import { Grid, Divider, Box, AppBar, Tabs, Tab, Chip } from "@material-ui/core";
// import trackFields from "../../../_module/definition/trackFields";
import clsx from "clsx";
import { _PermittedSetting } from "../../../_module/utils/PermittedSetting";
import moment from "moment";
import trackColumns from "../track/Columns";
import albumColumns from "../album/Columns";
import { ColumnTypes } from "../../../util/table-view/TableTypes";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import PlayerRef from "../../ml-player/PlayerRef/PlayerRef";
import TrackPreview from "../../../util/content-util/TrackPreview";
import HelpWrap from "../../ml-admin/help-admin/help-view/HelpWrap";
import { helpModules } from "../../ml-admin/help-admin/help-view/Const";
import CtagRulePreview from "../../../util/c-tag-util/CtagRulePreview";
import CliIcon from "images/sky-music.png";
import CliIconMain from "images/artwork.png";
import {
  showCtagRulePreview,
  emptyCtagRulePreview,
  getTrackHistory,
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  search,
  setQuery,
  prsSetHistory,
  focusItem,
  CreatePrsTrack,
  CreatePrsManualMatchTrack,
  // updatePrsData,
} from "../../../redux/actions/MlTrackLibraryActions";
import { updatePrsData } from "../../../redux/actions/MlAlbumTrackActions";
import { AuthSrc } from "./../../../util/AuthSrc";
import { getContributorDetails, getUserNameWithDetails } from "util/CommonFunc";
import { getChangeLogDetails } from "./../../../util/CommonFunc";
import MetaDataPopOut from "../../../_module/component/metadata-popout/metadata-popout";
import { albumTypes, PageTableType } from "redux/Types";
import { clearDownloads } from "../../../redux/actions/DownloadActions";
import PrsPopup from "_module/component/prs-popup/prs-popup";
import PrsDataPreview from "util/PrsDataPreview";
import { getUserDisplay } from "util/CommonFunc";
import TrackMetadataGrid from "_module/component/track-metadata-grid/track-metadata-grid";
import { DurationDisplayText } from "util/DurationDisplay";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tabpanel-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

class Preview extends Component {
  constructor() {
    super();
    this.state = {
      tabValue: 0,
    };
  }

  colsDefTrackAll = null;
  colsDefAlbumAll = null;

  generateColsDef(origin) {
    const {
      orgRuntime: {
        runtime: {
          _settingAlbumMetadataFieldsDefault:
          _settingAlbumMetadataFieldsDefault,
          _settingAlbumMetadataFieldsLibrary:
          _settingAlbumMetadataFieldsLibrary,
          _settingMetadataFieldsDefault: _settingMetadataFieldsDefault,
          _mlMetadata,
          _trackMetadataConfig,
          _albumMetadataConfig,
        },
      },
    } = this.props;
    const metaDataTrackSetting = _PermittedContent(
      [_mlMetadata, _trackMetadataConfig],
      []
    ) || { setting: [] };
    this.colsDefTrackAll =
      _PermittedSetting(
        metaDataTrackSetting.setting,
        _settingMetadataFieldsDefault
      ) || [];

    const metaDataAlbumSetting = _PermittedContent(
      [_mlMetadata, _albumMetadataConfig],
      []
    ) || { setting: [] };
    this.colsDefAlbumAll =
      _PermittedSetting(
        metaDataAlbumSetting.setting,
        _settingAlbumMetadataFieldsDefault
      ) || [];
  }

  a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  componentDidUpdate(prevProps) {
    const {
      mlTrackData: { showCtagRule },
      showCtagRulePreview,
      emptyCtagRulePreview,
      clearDownloads,
      data: { selectedItem },
    } = this.props;

    if (showCtagRule) {
      this.setState({ tabValue: 2 });
      showCtagRulePreview(false);
    }

    if (prevProps?.data?.selectedItem?.id !== selectedItem?.id) {
      clearDownloads();
    }
  }

  renderTrackMetadata = (id, i, classes, selectedItem, t, prop) => {
    const {
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _trackMusicOrigins: trackOrigins,
        },
      },
    } = this.props;

    let column = trackColumns[id];

    let value =
      selectedItem[id] && Array.isArray(selectedItem[id])
        ? selectedItem[id].join(", ")
        : selectedItem[id];

    return prop.tag ? (
      <div key={i} className={classes.trackTags}>
        <label
          className={
            id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
          }
          title={t(`track.${id}`)}>
          {t(`track.${id}`)}
        </label>
        {selectedItem[id] && Array.isArray(selectedItem[id])
          ? selectedItem[id].map((desc, i) => {
            return desc ? <Chip key={i} label={desc} /> : null;
          })
          : selectedItem[id]
            ? selectedItem[id]
            : ""}
      </div>
    ) : (
      <div key={i} className={classes.muDetailWrap}>
        <div
          className={clsx(
            id === "title" ? classes.muLabelsBold : classes.muLabels,
            classes.muLabels
          )}
          title={t(`track.${id}`)}>
          {t(`track.${id}`)}
        </div>
        <div className={classes.muSeperator}> :</div>
        {id === trackFields.prodName.id || id === trackFields.catNo.id ? (
          <div
            className={clsx(
              id === trackFields.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {(selectedItem?.is_mcf_track == true || selectedItem?.mlCreated == true) ? (
              <strong className="tablesLink">{value || ""}</strong>
            ) : (
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                key={selectedItem.id}
                to={`/search/album/${selectedItem.prodId}`}>
                <strong className="tablesLink">{value || ""}</strong>
              </Link>
            )}
          </div>
        ) : id === trackFields.duration.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={DurationDisplayText({ seconds: value }) || ""}>
            {DurationDisplayText({ seconds: value }) || ""}
          </div>
        ) : id == trackFields.contributorsExtended.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem.contributorsExtended
              ? getContributorDetails(selectedItem.contributorsExtended)
              : ""}
          </div>
        ) : id == trackFields.changeLog.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem.changeLog
              ? getChangeLogDetails(selectedItem.changeLog)
              : ""}
          </div>
        ) : trackFields[id] && trackFields[id].linkable ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {value &&
              value.split(",").map((data, i, array) => (
                <Link
                  style={{ textDecoration: "none", color: "#fff" }}
                  key={`${i}_${data}`}
                  aria-label={`Open Link ${t(`track.${id}`)}: ${data}`}
                  title={data}
                  to={{
                    pathname: `/search/tracks/${encodeURI(
                      data.trim().replace("/", "")
                    )}/${id}`,
                    state: {
                      q: `${data.trim()}`,
                      autofocus: false,
                    },
                  }}>
                  <strong class="tablesLink">
                    {data}
                    {i === array.length - 1 ? null : ", "}
                  </strong>
                </Link>
              ))}
          </div>
        ) : (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={
              column?.type === ColumnTypes.datetime ||
                column?.type === ColumnTypes.date
                ? null
                : id === trackFields.musicOrigin.id && value
                  ? t(`modules.originLables.${value}`)
                  : value || ""
            }>
            {column?.type === ColumnTypes.datetime ? (
              value ? (
                <Moment
                  format="DD/MM/YYYY h:mm:ss A"
                  titleFormat="DD/MM/YYYY h:mm:ss A"
                  withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.date ? (
              value ? (
                <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.users ? (
              value ? (
                getUserDisplay(String(value))
              ) : null
            ) : id === trackFields.org_sky_prodIsMCPSBlanket.id ||
              id === trackFields.org_sky_prodIsPPLBlanket.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  ""
                ) : value == false &&
                  id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                ) : value == false &&
                  id === trackFields.org_sky_prodIsPPLBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                ) : (
                  ""
                )}
              </div>
            ) : id === trackFields.org_sky_MCPS.id ||
              id === trackFields.org_sky_PPL.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {/* {value == true ? (
                  "No"
                ) : value == false && id === trackFields.org_sky_MCPS.id ? (
                  // <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                  <span className={classes.nonMCPSPPL}>Yes</span>
                ) : value == false && id === trackFields.org_sky_PPL.id ? (
                  // <span className={classes.nonMCPSPPL}>Non-PPL</span>
                  <span className={classes.nonMCPSPPL}>Yes</span>
                ) : (
                  ""
                )} */}
               {value == true ? (
                  "Yes"
                ) : value == false && id === trackFields.org_sky_MCPS.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                  // <span className={classes.nonMCPSPPL}>Yes</span>
                ) : value == false && id === trackFields.org_sky_PPL.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                  // <span className={classes.nonMCPSPPL}>Yes</span>
                ) : (
                  ""
                )}
              </div>
            ) : id === trackFields.org_sky_prodIsMCPSBlanket.id ||
              id === trackFields.org_sky_prodIsPPLBlanket.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  ""
                ) : value == false && id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                ) : value == false && id === trackFields.org_sky_prodIsPPLBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                ) : (
                  ""
                )}
              </div>
            ) : id === trackFields.musicOrigin.id && value ? (
              trackOrigins[value] && trackOrigins[value].label ? (
                trackOrigins[value].label
              ) : trackOrigins["origin" + value] &&
                trackOrigins["origin" + value].label ? (
                trackOrigins["origin" + value].label
              ) : (
                t(`modules.originLables.${value}`)
              )
            ) : column?.type === ColumnTypes.boolean ? (
              value ? (
                "True"
              ) : (
                "False"
              )
            ) : (
              value || ""
            )}
          </div>
        )}
      </div>
    );
  };

  renderAlbumMetadata = (id, i, classes, selectedItem, t, prop) => {
    const {
      orgRuntime: {
        runtime: { _albumFields: albumFields },
      },
    } = this.props;
    let column = albumColumns[id];
    let value =
      selectedItem[id] && Array.isArray(selectedItem[id])
        ? selectedItem[id].join(", ")
        : selectedItem[id];
    let selectedAlbumType;

    if (id === "org_sky_AlbumTypeID") {
      selectedAlbumType = albumTypes.find(
        (type) => type.id === selectedItem.org_sky_AlbumTypeID
      );
    }
    return prop.tag ? (
      <div key={i} className={classes.trackTags}>
        <label
          className={
            id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
          }
          title={t(`album.${id}`)}>
          {t(`album.${id}`)}
        </label>
        {selectedItem[id] && Array.isArray(selectedItem[id])
          ? selectedItem[id].map((desc, i) => {
            return desc ? <Chip key={i} label={desc} /> : null;
          })
          : selectedItem[id]
            ? selectedItem[id]
            : ""}
      </div>
    ) : (
      <div key={i} className={classes.muDetailWrap}>
        <div
          className={clsx(
            id === "title" ? classes.muLabelsBold : classes.muLabels,
            classes.muLabels
          )}
          title={t(`album.${id}`)}>
          {t(`album.${id}`)}
        </div>
        <div className={classes.muSeperator}> :</div>
        {id === albumFields.prodName.id || id === albumFields.catNo.id ? (
          <div
            className={clsx(
              id === albumFields.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {((selectedItem?.is_mcf_track == true || selectedItem?.mlCreated == true) ?
              <strong class="tablesLink">{value || ""}</strong> :
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                key={selectedItem.id}
                to={`/search/album/${selectedItem.prodId}`}>
                <strong class="tablesLink">{value || ""}</strong>
              </Link>
            )}
          </div>
        ) : albumFields[id] && albumFields[id].linkable ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {value &&
              value.split(",").map((data, i, array) => (
                <Link
                  style={{ textDecoration: "none", color: "#fff" }}
                  key={`${i}_${data}`}
                  aria-label={`Open Link ${t(`album.${id}`)}: ${data}`}
                  title={data}
                  to={{
                    pathname: `/search/albums/${encodeURI(
                      data.trim().replace("/", "")
                    )}/${id}`,
                    state: {
                      q: `${data.trim()}`,
                      autofocus: false,
                    },
                  }}>
                  <strong class="tablesLink">
                    {data}
                    {i === array.length - 1 ? null : ", "}
                  </strong>
                </Link>
              ))}
          </div>
        ) : (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={
              column?.type === ColumnTypes.datetime ||
                column?.type === ColumnTypes.date
                ? null
                : id === albumFields.musicOrigin.id && value
                  ? t(`modules.originLables.${value}`)
                  : id === "org_sky_AlbumTypeID"
                    ? selectedAlbumType
                      ? selectedAlbumType.label
                      : ""
                    : value || ""
            }>
            {column?.type === ColumnTypes.datetime ? (
              value ? (
                <Moment
                  format="DD/MM/YYYY h:mm:ss A"
                  titleFormat="DD/MM/YYYY h:mm:ss A"
                  withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.date ? (
              value ? (
                <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.users ? (
              value ? (
                getUserDisplay(String(value))
              ) : null
            ) : id === albumFields.org_sky_IsMCPSBlanket.id ||
              id === albumFields.org_sky_IsPPLBlanket.id ? (
              <div
                className={clsx(
                  id === albumFields.prodName.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  ""
                ) : value == false &&
                  id === albumFields.org_sky_IsMCPSBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                ) : value == false &&
                  id === albumFields.org_sky_IsPPLBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                ) : (
                  ""
                )}
              </div>
            ) : id === albumFields.org_sky_trackMCPS.id ||
              id === albumFields.org_sky_trackPPL.id ? (
              <div
                className={clsx(
                  id === albumFields.prodName.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  "Yes"
                ) : value == false &&
                  id === albumFields.org_sky_trackMCPS.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                ) : value == false &&
                  id === albumFields.org_sky_trackPPL.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                ) : (
                  ""
                )}
              </div>
            ) : id === albumFields.musicOrigin.id && value ? (
              t(`modules.originLables.${value}`)
            ) : column?.type === ColumnTypes.boolean ? (
              value ? (
                "True"
              ) : (
                "False"
              )
            ) : id === "org_sky_AlbumTypeID" ? (
              selectedAlbumType ? (
                selectedAlbumType.label
              ) : (
                ""
              )
            ) : (
              value || ""
            )}
          </div>
        )}
      </div>
    );
  };

  getIpsText = (ipsArray) => {
    try {
      if (Array.isArray(ipsArray)) {
        return ipsArray
          ?.filter((r) => r?.fullName)
          .map((r) => r?.fullName)
          ?.join(", ");
      } else {
        return null;
      }
    } catch {
      return null;
    }
  };

  renderAdminNotes = (selectedItem, classes, t) => {
    return (
      <>
        <div className={classes.muDetailWrap}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Admin Notes`}
            className={classes.muLabels}>{`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Admin Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcAdminNotes || ""}>
            {selectedItem?.bbcAdminNotes || ""}
          </div>
        </div>
        <div className={classes.muDetailWrap}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Librarian Notes`}
            className={classes.muLabels}>{`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Librarian Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLibrarianNotes || ""}>
            {selectedItem?.bbcLibrarianNotes || ""}
          </div>
        </div>
        <div className={classes.muDetailWrap}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Licence Notes`}
            className={classes.muLabels}>{`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Licence Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLicenceNotes || ""}>
            {selectedItem?.bbcLicenceNotes || ""}
          </div>
        </div>
      </>
    );
  };
  calcHeight() {
    if (!this.toolWrapper) return 279;
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height + 85;
  }

  calcHeightinner() {
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height - 150;
  }
  render() {
    let selectedItem;
    const {
      classes,
      data: {
        selectedItem: selectedItemForPreview,
        album,
        postUpdating,
        PRSHistoryLoading,
        query,
      },
      updateData: { trackEditing },
      item,
      prsTrackUnlink,
      prsHistorySearch,
      search,
      prsMechanicalOverride,
      prsSetHistory,
      CreatePrsTrack,
      focusItem,
      updatePrsData,
      isPopOut,
      CreatePrsManualMatchTrack,
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _albumFields: albumFields,
          _mlMetadata,
          _canSeeAdminNotes,
          _extendedTrackPreviewMetadata,
        },
      },
    } = this.props;

    if (this.props?.isPopOut) {
      selectedItem = item;
    } else {
      selectedItem = selectedItemForPreview;
    }

    if (selectedItem && selectedItem.id)
      this.generateColsDef(
        (selectedItem[trackFields.musicOrigin.id] || "").toLowerCase()
      );
    const canViewAdminNotes = _PermittedContent(
      [_mlMetadata, _canSeeAdminNotes],
      []
    )
      ? true
      : false;
    return (
      <Translation>
        {(t, { i18n }) => (
          <Paper className={classes.sideBar} role="contentinfo">
            {trackEditing ? (
              <>
                <TrackPreview {...this.props} />
              </>
            ) : selectedItem && selectedItem.id ? (
              <>
                {!this.props?.isPopOut && (
                  <>
                    <Paper className={classes.disFlex}>
                      <h2 className={classes.muTitle}>
                        {(selectedItem[trackFields.trackTitle.id] &&
                          Array.isArray(selectedItem[trackFields.trackTitle.id])
                          ? selectedItem[trackFields.trackTitle.id].join(", ")
                          : selectedItem[trackFields.trackTitle.id]) ||
                          t("libraryPreview.na")}
                        <span className={classes.muSubTitle}>
                          {(selectedItem[trackFields.performer.id] &&
                            Array.isArray(selectedItem[trackFields.performer.id])
                            ? selectedItem[trackFields.performer.id].join(", ")
                            : selectedItem[trackFields.performer.id]) ||
                            t("libraryPreview.na")}
                        </span>
                      </h2>
                      <HelpWrap config={helpModules.ATSPWH} />
                      <DownloadLink track={selectedItem} />
                    </Paper>
                    <div style={{ display: "flex" }}>
                      <div
                        className={classes.trackEditContainer}
                        ref={(div) => (this.toolWrapper = div)}>
                        <Paper>
                          <Box
                            className={classes.artworkHolder}
                            tabIndex="-1"
                            p={1}>
                            <Grid
                              container
                              direction="column"
                              alignItems="center"
                              justify="center"
                              tabIndex="-1">
                              {selectedItem[trackFields.prodArtworkUrl.id] ? (
                                <img
                                  style={{ height: 240, width: 240 }}
                                  src={AuthSrc(
                                    selectedItem[trackFields.prodArtworkUrl.id]
                                  )}
                                  alt={
                                    selectedItem[trackFields.trackTitle.id] ||
                                    ""
                                  }
                                />
                              ) : (
                                <Grid
                                  container
                                  direction="column"
                                  alignItems="center"
                                  justify="center">
                                  <img
                                    className={"emptyArtwork"}
                                    src={CliIconMain}
                                    alt="Sky Music"
                                  />

                                  {/* <MusicNoteIcon style={{ fontSize: 60 }} /> */}
                                </Grid>
                              )}
                            </Grid>
                            {postUpdating ? null : (
                              <PlayerRef
                                className={classes.playTrackButton}
                                key={selectedItem.id}
                                aria-label="Play"
                                item={selectedItem}
                                popoutFor={PageTableType.SEARCH_ALBUM_TRACKS}
                              />
                            )}
                          </Box>
                        </Paper>
                      </div>
                      <div className={classes.popOutBlock}>
                        {
                          <MetaDataPopOut
                            popoutFor={PageTableType.SEARCH_ALBUM_TRACKS}
                            data={selectedItem}
                          />
                        }
                        {
                          <PrsPopup
                            prsTrackUnlink={prsTrackUnlink}
                            prsHistorySearch={prsHistorySearch}
                            prsmechanicaloverride={prsMechanicalOverride}
                            PRSHistoryLoading={PRSHistoryLoading}
                            popoutFor={PageTableType.SEARCH_TRACKS}
                            mbTrackData={selectedItem}
                            prsTrackData={selectedItem?.prsTrack}
                            updatePrsData={updatePrsData}
                            // trackSearch={() => {
                            //   search(query);
                            // }}
                            prsSetHistory={prsSetHistory}
                            // focusItem={focusItem}
                            CreatePrsTrack={CreatePrsTrack}
                            mlsearch={search}
                            CreatePrsManualMatchTrack={
                              CreatePrsManualMatchTrack
                            }
                          />
                        }
                      </div>
                    </div>
                  </>
                )}
                <AppBar className={classes.trackTabsHeader} position="static">
                  <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabChange}
                    scrollButtons="auto"
                    variant="scrollable">
                    <Tab 
                    label={this.props?.isPopOut ? "Metadata" : "Track Metadata"}
                    {...this.a11yProps(0)} />
                    {_extendedTrackPreviewMetadata &&
                      _extendedTrackPreviewMetadata.prsMetadata != null && (
                        <Tab label="PRS" {...this.a11yProps(1)} value={1} />
                      )}
                    <Tab label="Album" {...this.a11yProps(2)} />
                    <Tab label="C-Tag Rules" {...this.a11yProps(3)} />
                  </Tabs>
                </AppBar>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={0}>
                  {!isPopOut ?
                    <Paper
                      className={classes.sidebarDataContainer}
                      style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                      <div
                        className={classes.sidebarWrappedDataDark}
                        style={{
                          height: `calc(100% - ${this.calcHeightinner()}px)`,
                        }}>
                        {this.colsDefTrackAll?.map((id, i) => {
                          const prop = trackFields[id] || {};
                          return this.renderTrackMetadata(
                            id,
                            i,
                            classes,
                            selectedItem,
                            t,
                            prop
                          );
                        })}
                        {canViewAdminNotes &&
                          this.renderAdminNotes(selectedItem, classes, t)}
                      </div>
                    </Paper>
                    : (<TrackMetadataGrid data={item} classes={classes} />)}

                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={1}>
                  {!isPopOut ? <Paper
                    className={classes.sidebarDataContainer}
                    style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                    <div
                      className={classes.sidebarWrappedDataDark}
                      style={{
                        height: `calc(100% - ${this.calcHeightinner()}px)`,
                      }}>
                      <PrsDataPreview
                        classes={classes}
                        selectedItem={selectedItem}
                      />
                    </div>
                  </Paper>
                    :
                    <Paper className={classes.paperwrap}>
                      <div className={clsx(classes.muListWrap, "popupWindow")}>
                        <PrsDataPreview
                          classes={classes}
                          selectedItem={selectedItem}
                        />
                      </div>
                    </Paper>
                  }

                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={2}>
                  {!isPopOut ?
                    <Paper
                      className={classes.sidebarDataContainer}
                      style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                      <div
                        className={classes.sidebarWrappedDataDark}
                        style={{
                          height: `calc(100% - ${this.calcHeightinner()}px)`,
                        }}>
                        {this.colsDefAlbumAll?.map((id, i) => {
                          const prop = albumFields[id] || {};
                          return this.renderAlbumMetadata(
                            id,
                            i,
                            classes,
                            album ?? {},
                            t,
                            prop
                          );
                        })}
                      </div>
                    </Paper>
                    :
                    <Paper className={classes.paperwrap}>
                      <div className={clsx(classes.muListWrap, "popupWindow")}>
                        {this.colsDefAlbumAll?.map((id, i) => {
                          const prop = albumFields[id] || {};
                          return this.renderAlbumMetadata(
                            id,
                            i,
                            classes,
                            album ?? {},
                            t,
                            prop
                          );
                        })}
                      </div>
                    </Paper>
                  }

                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={3}>
                  <CtagRulePreview  classes={this.props.isPopOut? classes : null}  />
                </TabPanel>
              </>
            ) : (
              <div className={classes.noData}>
                <img style={{ width: 120 }} src={CliIcon} alt="Sky Music" />
                {/* <MusicNoteIcon style={{ fontSize: 60, marginBottom: 20 }} /> */}
                {/* {t("libraryPreview.noPreview")} */}
              </div>
            )}
          </Paper>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mlalbumtrack,
  updateData: state.mlTrackUpdateReducer,
  mlTrackData: state.mltracklibrary,
  orgRuntime: state.orgRuntime,
  users: state.inbox.allUsers,
});

export default connect(mapStateToProps, {
  showCtagRulePreview,
  emptyCtagRulePreview,
  clearDownloads,
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  search,
  prsSetHistory,
  CreatePrsTrack,
  focusItem,
  setQuery,
  updatePrsData,
  CreatePrsManualMatchTrack,
})(withStyles(styles)(Preview));
